function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Master",
  stroke: "none",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  transform: "translate(-200.000000, -318.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Status-icon/-shipped",
  transform: "translate(200.000000, 318.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "checkmark-circle-outline-copy",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,8 C16,3.58333333 12.4166667,0 8,0 C3.58333333,0 0,3.58333333 0,8 C0,12.4166667 3.58333333,16 8,16 C12.4166667,16 16,12.4166667 16,8 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "airplane",
  transform: "translate(3.000000, 4.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.55444533,8 L2.99985012,8 C2.88661917,8 2.78114989,7.94687547 2.719796,7.85902996 C2.65844211,7.77118444 2.64959418,7.66059667 2.69630196,7.56538462 L4.03924738,4.82980769 L2.02274587,4.78846154 L1.28731346,5.61096154 C1.14710212,5.77365385 1.03522473,5.84615385 0.749801949,5.84615385 L0.376460622,5.84615385 C0.256494368,5.8497182 0.142186151,5.79904325 0.0702040648,5.71038462 C0.0206196698,5.64865385 -0.028131374,5.54403846 0.0193696431,5.39480769 L0.432295151,4.02942308 C0.435420218,4.01923077 0.439170298,4.00903846 0.443337054,3.99903846 C0.443544692,3.99808647 0.443544692,3.99710583 0.443337054,3.99615385 C0.439034497,3.98616196 0.435347969,3.97595333 0.432295151,3.96557692 L0.0189529675,2.59153846 C-0.0258396582,2.44519231 0.0231197234,2.34288462 0.0722874427,2.28269231 C0.139242327,2.20068557 0.244384575,2.15287303 0.355626843,2.15384615 L0.749801949,2.15384615 C0.962931512,2.15384615 1.16981094,2.24211538 1.29148021,2.38461538 L2.01170397,3.19326923 L4.03924738,3.16557692 L2.69671863,0.434807692 C2.64994682,0.339639174 2.65870266,0.229063129 2.71996891,0.141183653 C2.78123516,0.0533041769 2.88663578,0.000135744346 2.99985012,0 L3.56048713,0 C3.71892819,0.00293898799 3.86730113,0.0723020756 3.96362076,0.188461538 L6.56888487,3.11153846 L7.77245231,3.08230769 C7.86057919,3.07788462 8.10475109,3.07634615 8.16121063,3.07634615 C9.31248528,3.07692308 10,3.42192308 10,4 C10,4.18192308 9.92124831,4.51923077 9.39436203,4.73384615 C9.08331371,4.86076923 8.66830482,4.925 8.16079396,4.925 C8.10495943,4.925 7.86141255,4.92346154 7.77203563,4.91903846 L6.56867653,4.88942308 L3.95695395,7.8125 C3.86056015,7.92814165 3.71248767,7.99711804 3.55444533,8 Z",
  id: "Path"
})))));

var SvgShipped = function SvgShipped(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShipped, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shipped.d94beeda.svg";
export { ForwardRef as ReactComponent };